import LogOutput from '@shell/models/logging.banzaicloud.io.output';

export default class LogClusterOutput extends LogOutput {
}
